import styled from "styled-components";
import Button from "@mui/material/Button";

const SubmitButton = styled(Button)`
  && {
    margin: 0;
    margin-top: 0.5rem;
    margin-inline: auto;
    align-self: center;
  }
`;

export default SubmitButton;
